/*
 * Copyright (c) 2016 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ICON_DIRECTIVES } from "./index";
var ClrIconModule = (function () {
    function ClrIconModule() {
    }
    return ClrIconModule;
}());
export { ClrIconModule };
ClrIconModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule],
                declarations: [ICON_DIRECTIVES],
                exports: [ICON_DIRECTIVES]
            },] },
];
/** @nocollapse */
ClrIconModule.ctorParameters = function () { return []; };
//# sourceMappingURL=icon.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/icon/icon.module.js
// module id = 12
// module chunks = 4